import {
    Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ToastMessage } from '../../toast-message/toast-message.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LogService } from '../../log-service.service';
import { ConstantsService } from '../../constants.service';
import { AadharService } from './aadhar.service';
import { OnboardingPageService } from '../onboarding-page.service';
import { MatDialog } from '@angular/material';
import { PopUpMessageComponent } from '../../pop-up-message/pop-up-message.component';
import { Subject } from 'rxjs';
import { ImageZoomService } from '../../services/image-zoom.service';
const constants = require('../../../../server/utils/constants');

const _ = require('lodash');
@Component({
    selector: 'app-aadhar',
    template: require('./aadhar.component.html'),
    providers: [AadharService]
})
export class AadharComponent implements OnInit, OnChanges, OnDestroy {
    aadharNumberFormControl = new FormControl('', [
        Validators.pattern('[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}'),
        Validators.required
    ]);
    aadharNameFormControl = new FormControl('');
    verfiedMessage: string;

    constructor(private _aadharService: AadharService,
        private _toastMessage: ToastMessage,
        private spinnerService: Ng4LoadingSpinnerService,
        private _logService: LogService,
        private constantService: ConstantsService,
        private dialog: MatDialog,
        private _onboardingService: OnboardingPageService,
        private imageZoomService: ImageZoomService) {
    }
    @Input() data: any;
    @Input() showFront = false;
    @Input() showBack = false;
    @Input() userIdentity: any;
    @Input() existingAadharStatus: any;
    @Input() allowEditing: any;
    @Input() aadharDoc: any;
    @Input() isAadharRejected: any;

    @Output() aadharStatus: EventEmitter<any> = new EventEmitter();
    @Output() fetchData: EventEmitter<any> = new EventEmitter();
    @Output() aadharFrontImage: EventEmitter<any> = new EventEmitter();
    @Output() aadharBackImage: EventEmitter<any> = new EventEmitter();
    @Output() addAadharToRejectList: EventEmitter<any> = new EventEmitter();

    public screenBreakpoint = false;
    public aadharData: any;
    public updateImageEnabled = false;
    public config: any;
    public userId: any;
    public aadharNumber: String;
    public aadharAutoApproved = false;
    public existingAadharNumber: String;
    public aadharName: String;
    public existingAadharName: String;
    public remarks: String;
    public riderId: any;
    public imgFront: any;
    public imgBack: any;
    public imgFrontData: any;
    public imgBackData: any;
    public showApproveButton = false;
    public showVerifyButton = false;
    public showButtonIcon = false;
    public aadharRemarks = [];
    public aadharApprovalStatus = 'Approved';
    public aadharApprovalMessage: any;
    public isAadharApproved = false;
    public APPROVAL_MESSAGE = this.constantService.approvalMessage;

    public isAadharDocStatusAvailable: boolean;
    public isAadharBackOptional: boolean;
    public isAadharInKyc = false;
    public isAadharVerified = false;
    public isActive = false;
    public aadharVerifyStatus: any;
    public aadharVerifyMessage: any;
    public verificationPlatform: any;
    public verifiedOn: any;
    public thirdPartyMessage: any;
    public thirdPartyStatus: any;
    public changedDetailsOfDoc = [];

    public verificationStatus = {
        ACCEPTED: 'Accepted',
        WARNING: 'Warning',
        REJECTED: 'Rejected',
        VERIFIED: 'Verified'
    };

    public asyncRefreshTrigger: Subject<void> = new Subject<void>();

    /** Sticky Aadhaar duplicate indication — stays until agent dismisses (unlike DL auto-dismiss toast). */
    public duplicateErrorMessage: string = null;
    private duplicateBannerDismissed = false;
    private stickyDuplicateSnackRef: any = null;

    private invalidAadhar = 'Aadhar is a mandatory field. It can not contain any' +
        ' special characters and has a limit of 12 characters';
    private isExistingAadhar = 'Aadhar number already exists.';

    private rotateFrontImageDegrees = 0;
    private rotateBackImageDegrees = 0;
    onResize(event) {
        this.screenBreakpoint = (event.target.innerWidth <= 1040) ? true : false;

    }

    addToBulkRejection(event) {
        this.addAadharToRejectList.emit(event);
    }

    showDocDetailsChangeTypePanel() {
        if (this.existingAadharNumber !== undefined && this.existingAadharNumber !== null && this.existingAadharNumber.trim() !== '' && this.existingAadharNumber !== this.aadharNumber) {
            this.changedDetailsOfDoc.push(`Existing Number: ${this.existingAadharNumber}`)
            this.changedDetailsOfDoc.push(`New Number: ${this.aadharNumber}`)
            this.showButtonIcon = true;
        }
        if (this.existingAadharName !== undefined && this.existingAadharName !== null && this.existingAadharName.trim() !== '' && this.existingAadharName !== this.aadharName) {
            this.changedDetailsOfDoc.push(`Existing Name: ${this.existingAadharName}`)
            this.changedDetailsOfDoc.push(`New Name: ${this.aadharName}`)
            this.showButtonIcon = true;
        }
        if (this.remarks !== undefined && this.remarks !== null && this.remarks.trim() !== '' && this.remarks !== this.aadharData.aadhar.remarks) {
            this.changedDetailsOfDoc.push(`Existing Remarks: ${this.remarks}`)
            this.changedDetailsOfDoc.push(`New Remarks: ${this.aadharData.aadhar.remarks}`)
        }
    }

    private openChangeDetailsDialog(actionFunction: () => void): void {
        const dialogRef = this.dialog.open(PopUpMessageComponent, {
            width: '550px',
            data: {
                options: [],
                title: 'Please confirm for the changed details in aadhar',
                message: '',
                data: {
                    type: 'orderedList',
                    info: this.changedDetailsOfDoc,
                    note: 'Are you sure you want to update above details',
                },
                reason: 'changeDocDetails',
                buttonText: 'Yes',
                cancelText: 'No',
                styles: {
                    title: 'font-size-20 margin-bottom-30',
                    actionClass: 'doc-details-change-confirm',
                    note: 'margin-bottom-12 margin-top-30 color-grey'
                }
            }
        });

        dialogRef.afterClosed().subscribe(confirm => {
            if (confirm) {
                actionFunction();
            } else {
                this.aadharNumber = this.existingAadharNumber;
                this.showButtonIcon = false;
                this.showVerifyButton = false;
            }
            this.changedDetailsOfDoc.splice(0, this.changedDetailsOfDoc.length);
        });
    }

    viewDetailsForChangedDocs() {
        this.showDocDetailsChangeTypePanel()
        if (this.changedDetailsOfDoc.length > 0) {
            this.openChangeDetailsDialog(() => this.approveAadhar());
        } else {
            this.approveAadhar();
        }
    }

    viewDetailsForChangedDocsForAadharUpdate() {
        if (this.existingAadharNumber !== undefined && this.existingAadharNumber !== null && this.existingAadharNumber.trim() !== '' && this.existingAadharNumber !== this.aadharNumber) {
            this.changedDetailsOfDoc.push(`Existing Number: ${this.existingAadharNumber}`)
            this.changedDetailsOfDoc.push(`New Number: ${this.aadharNumber}`)
            this.showButtonIcon = true;
        }
        if (this.changedDetailsOfDoc.length > 0) {
            this.openChangeDetailsDialog(() => this.updateAadharNumber());
        } else {
            this.updateAadharNumber();
        }
    }

    updateAadharNumber() {
        return new Promise(() => {
            if (this.isInvalid()) {
                this._toastMessage.openSnackBarError(this.invalidAadhar);
                this.spinnerService.hide();
            } else if (this.isExisting()) {
                this._toastMessage.openSnackBarError(this.isExistingAadhar);
                this.spinnerService.hide();
            } else {
                this._aadharService.updateNumber(this.data._id, this.aadharNumber.toUpperCase()).subscribe(res => {
                    this.showApproveButton = true;
                    this.showVerifyButton = true;
                    this.showButtonIcon = false;
                    this.isAadharApproved = false;
                    this.isAadharVerified = false;
                    this.spinnerService.hide();
                    this.existingAadharNumber = res["data"]["aadhar"]["number"];
                    this.dismissDuplicateError();
                    this._toastMessage.openSnackBarSuccess('Aadhar number is updated!');
                },
                    error => {
                        this.spinnerService.hide();
                        this.handleAadhaarApiError(error, 'Could not update aadhar number');
                    });
            }
        });
    }

    viewDetailsForAadharNameUpdate() {
        if (this.existingAadharName !== undefined && this.existingAadharName !== null && String(this.existingAadharName).trim() !== '') {
            if (this.aadharName !== this.existingAadharName) {
                this.changedDetailsOfDoc.push(`Existing Aadhar Name: ${this.existingAadharName}`);
                this.changedDetailsOfDoc.push(`New Aadhar Name: ${this.aadharName}`);
                this.showButtonIcon = true;
                this.openChangeDetailsDialog(() => this.updateAadharName());
            } else {
                this.aadharName = this.existingAadharName;
            }
        } else {
            this.updateAadharName();
        }
    }

    updateAadharName() {
        if (this.aadharName === this.existingAadharName) {
            this._toastMessage.openSnackBarError('No update required. You entered same Aadhar name');
        } else if (!this.aadharName || !String(this.aadharName).trim()) {
            this._toastMessage.openSnackBarError('Please enter Aadhar name to update.');
        } else {
            this.spinnerService.show();
            this._aadharService.updateName(this.data._id, String(this.aadharName).trim()).subscribe(res => {
                this.spinnerService.hide();
                this.existingAadharName = this.aadharName;
                if (this.aadharData && this.aadharData.aadhar) {
                    this.aadharData.aadhar.name = this.aadharName;
                }
                this.showButtonIcon = false;
                this._toastMessage.openSnackBarSuccess('Aadhar Name is updated!');
            },
                error => {
                    this.spinnerService.hide();
                    const errorMessage = error && error.error && error.error.message || 'Could not update Aadhar name';
                    this._toastMessage.openSnackBarError(errorMessage, this.constantService.errorToastDuration);
                });
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.riderId = changes.data.currentValue._id;
            await this._onboardingService.getRiderDetails(this.riderId).subscribe((res: any) => {
                this.aadharData = res.data;
                this.aadharNumber = this.aadharData.aadhar.number;
                this.existingAadharNumber = this.aadharData.aadhar.number;
                this.aadharName = this.aadharData.aadhar.name ? this.aadharData.aadhar.name : '';
                this.existingAadharName = this.aadharData.aadhar.name ? this.aadharData.aadhar.name : '';
                this.isAadharBackOptional = this.aadharData && this.aadharData.aadhar && this.aadharData.aadhar.isAadharBackOptional || false;
                this.remarks = this.aadharData.aadhar.remarks;
                this.isAadharInKyc = this.aadharData.aadhar.dataIsInKyc || false;
                this.isAadharDocStatusAvailable = this.isAadharDocStatusPresent(this.aadharData.docVerificationStatus);
                this.thirdPartyMessage = this.aadharData.docVerificationStatus && this.isAadharDocStatusAvailable ? this.aadharData.docVerificationStatus.aadhar.message : '';
                this.thirdPartyStatus = this.aadharData.docVerificationStatus && this.isAadharDocStatusAvailable ? this.aadharData.docVerificationStatus.aadhar.status : '';
                this.isAadharVerified = this.thirdPartyStatus === this.verificationStatus.VERIFIED || this.thirdPartyStatus === this.verificationStatus.ACCEPTED;
                this.isActive = this.aadharData.active;
                this.verificationPlatform = this.aadharData.docVerificationStatus && this.isAadharDocStatusAvailable ? this.aadharData.docVerificationStatus.aadhar.verifiedBy : '';
                this.verifiedOn = this.aadharData.docVerificationStatus && this.isAadharDocStatusAvailable ? this.aadharData.docVerificationStatus.aadhar.verifiedOn : '';
                this.riderId = this.aadharData._id;
                this.imgFront = this.aadharData.aadhar.frontLink;
                this.imgBack = this.isAadharBackOptional ? "" : this.aadharData.aadhar.backLink;
                if (this.aadharData.aadhar.frontLink && (this.isAadharBackOptional || this.aadharData.aadhar.backLink) && this.aadharData.aadhar.verified === false) {
                    this.showApproveButton = true;
                    this.showVerifyButton = true;
                }
                if (this.aadharData.aadhar.frontLink && this.aadharData.aadhar.verified === false) {
                    this.showVerifyButton = true;
                }
                if (changes && changes.allowEditing && changes.allowEditing.currentValue === false) {
                    this.aadharNumberFormControl.disable();
                    this.aadharNameFormControl.disable();
                }
                if (this.aadharData && this.aadharData.aadhar && this.aadharData.aadhar.verified) {
                    this.formApprovalMessage();
                }
                if (this.aadharAutoApproved || this.isAadharVerified) {
                    this.showVerifyButton = false;
                }
                this.maybeShowDuplicateFromDoc(this.aadharData);

            });
        }
    }

    ngOnInit() {
        // Show BlowupLens using vanilla JavaScript
        const blowupLens = document.getElementById('BlowupLens');
        if (blowupLens) {
            blowupLens.style.display = 'block';
        }
        this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
    }

    formApprovalMessage() {
        const aadharAutoApprovalStatus = this.aadharData['autoApprovalStatus'] || {};
        this.isAadharApproved = true;
        if (aadharAutoApprovalStatus['aadharVerificationStatus']
            && aadharAutoApprovalStatus['aadharVerificationStatus'].autoApproved
        ) {
            this.aadharAutoApproved = true;
            this.aadharApprovalMessage = this.APPROVAL_MESSAGE.autoApproved;
        } else {
            this.aadharApprovalMessage = this.APPROVAL_MESSAGE.agentApproved;
        }
    }

    isAadharDocStatusPresent(docVerificationStatus) {
        if (docVerificationStatus) {
            return docVerificationStatus.aadhar ? true : false;
        }
    }

    rotateImage(link, degrees, key) {
        if (key === 'front') {
            this.rotateFrontImageDegrees += degrees;
            degrees = this.rotateFrontImageDegrees;
        } else {
            this.rotateBackImageDegrees += degrees;
            degrees = this.rotateBackImageDegrees;
        }
        let response;
        this.spinnerService.show();
        this._aadharService.rotateImage(link, degrees).subscribe(resp => {
            response = resp;
            this.spinnerService.hide();
            if (key === 'front') {
                this.imgFrontData = response.data;
                setTimeout(() => {
                    this.updateImageEnabled = true;
                    const displayImage = document.getElementById('displayImage') as HTMLImageElement;
                    if (displayImage) {
                        displayImage.src = response.data;
                        this.imageZoomService.initImageZoom('displayImage', {
                            width: 400,
                            height: 400,
                            border: '1px solid black',
                            round: false
                        });
                    }
                }, 300);
            }
            if (key === 'back') {
                this.imgBackData = response.data;
                setTimeout(() => {
                    this.updateImageEnabled = true;
                    const displayImage = document.getElementById('displayImage') as HTMLImageElement;
                    if (displayImage) {
                        displayImage.src = response.data;
                        this.imageZoomService.initImageZoom('displayImage', {
                            width: 400,
                            height: 400,
                            border: '1px solid black',
                            round: false
                        });
                    }
                }, 300);
            }
        },
            error => {
                this.spinnerService.hide();
                const errorMessage = error && error.error && error.error.message || 'Could not rotate image';
                this._toastMessage.openSnackBarError(errorMessage);
            });
    }

    updateAadharFrontImage() {
        let response;
        const riderId = this.data._id;
        this._aadharService.updateImage('front', this.imgFront, riderId, this.imgFrontData).subscribe(resp => {
            this.fetchData.emit(true);
            response = resp;
            this._toastMessage.openSnackBarSuccess('Image has been updated');
            this._toastMessage.openSnackBarSuccess('Image Saved. Please reload.');
            this.updateImageEnabled = false;
            this.rotateFrontImageDegrees = 0;
            this.refreshDisplayImage();
        },
            error => {
                const errorMessage = error && error.error && error.error.message || 'Could not update Aadhar front image';
                this._toastMessage.openSnackBarError(errorMessage);
            });
    }

    updateAadharBackImage() {
        let response;
        const riderId = this.data._id;
        this._aadharService.updateImage('back', this.imgBack, riderId, this.imgBackData).subscribe(resp => {
            this.fetchData.emit(true);
            response = resp;
            this._toastMessage.openSnackBarSuccess('Image has been updated');
            this._toastMessage.openSnackBarSuccess('Image Saved. Please reload.');
            this.updateImageEnabled = false;
            this.rotateBackImageDegrees = 0;
            this.refreshDisplayImage();
        },
            error => {
                const errorMessage = error && error.error && error.error.message || 'Could not update Aadhar back image';
                this._toastMessage.openSnackBarError(errorMessage);
            });
    }

    refreshDisplayImage() {
        // Initialize image zoom with vanilla JavaScript
        setTimeout(() => {
            this.imageZoomService.initImageZoom('displayImage', {
                width: 400,
                height: 400,
                border: '1px solid black',
                round: false
            });
        }, 100);

        // Show BlowupLens using vanilla JavaScript
        const blowupLens = document.getElementById('BlowupLens');
        if (blowupLens) {
            blowupLens.style.display = 'block';
        }
        this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
    }

    updateImageUrl(evt: any) {
        this.fetchData.emit(true);
        if (evt.view === 'front') {
            this.imgFront = evt.url;
            this.aadharFrontImage.emit(this.imgFront);
        } else if (evt.view === 'back') {
            this.imgBack = evt.url;
        }
        if (evt.mode === 'delete') {
            const aadharStatus = {
                'data': {},
                'status': this.verificationStatus.WARNING,
                'message': null,
                'isAadharAccepted': false,
                verifiedBy: null,
                verifiedOn: null
            };
            const condition = {
                'docVerificationStatus.aadhar': aadharStatus
            };

            this.updateRider(condition);
            this.aadharStatus.emit(false);
            this.showApproveButton = false;
            this.showVerifyButton = false;
            this.updateImageEnabled = false;
            // Hide BlowupLens using vanilla JavaScript
            const blowupLens = document.getElementById('BlowupLens');
            if (blowupLens) {
                blowupLens.style.display = 'none';
            }
        }
        if (evt.mode === 'update') {
            this.showApproveButton = true;
            this.showVerifyButton = true;
            this._toastMessage.openSnackBarSuccess('Image Saved. Please reload using Shift + R .');
        }
    }

    async approveAadhar() {
        this.spinnerService.show();
        if ((!this.aadharNumber) || (this.aadharNumberFormControl.errors && this.aadharNumberFormControl.errors.required)) {
            this._toastMessage.openSnackBarError('Aadhar Number is a mandatory field. It can not be empty');
            this.spinnerService.hide();
            return
        } else if ((!this.aadharName) || (this.aadharNameFormControl.errors && this.aadharNameFormControl.errors.required)) {
            this._toastMessage.openSnackBarError('Aadhar Name is a mandatory field. It can not be empty');
            this.spinnerService.hide();
            return
        }

        if (this.isNumberChanged && this.isNameChanged) {
            await this.updateAadharInfoAndRemarksForApproval();
        } else if (this.isNumberChanged) {
            await this.updateAadharNumber();
            await this.updateAadharVerifiedAndRemarks();
        } else if (this.isNameChanged) {
            this.updateAadharName();
            await this.updateAadharVerifiedAndRemarks();
        } else if (this.existingAadharNumber) {
            await this.updateAadharVerifiedAndRemarks();
        } else {
            this.spinnerService.hide();
            this._toastMessage.openSnackBarError('Make sure you have entered all the mandatory data');
        }
    }

    private isNumberChanged() {
        return (!this.existingAadharNumber || (this.aadharNumber && this.existingAadharNumber &&
            (this.existingAadharNumber.toUpperCase() !== this.aadharNumber.toUpperCase())));
    }

    private isNameChanged() {
        return (!this.existingAadharName|| (this.aadharName && this.existingAadharName &&
            (String(this.existingAadharName).trim().toUpperCase() !== String(this.aadharName).trim().toUpperCase()))) ;
    }

    onVerifyAadhar = () => {
        const captainData = this.data;
        const payload = {
            image: this.imgFront,
            backImage: this.imgBack,
            profilePicture: this.aadharData && this.aadharData.profilePicture && this.aadharData.profilePicture.link,
            name: `${captainData.firstName} ${captainData.lastName}`,
            referenceId: this.data._id,
            documentType: 'aadhar',
            verificationType: 'ocrgc',
            actorId: this.aadharDoc.actorId,
            actorType: constants.ACTOR_TYPE.AGENT,
            docNumber: this.aadharNumber,
            isAadharInKyc: this.isAadharInKyc,
        };
        this.showVerifyButton = false;
        this.spinnerService.show();
        this._aadharService.verifyAadhar(payload)
            .subscribe((result: any) => {
                this.asyncRefreshTrigger.next();
                this.spinnerService.hide();

                if (result && result['status'] === 'success') {
                    this._toastMessage.openSnackBarSuccess(result['data']);
                    this.showVerifyButton = false;
                } else {
                    this._toastMessage.openSnackBarError('Faced problem in verification of docs');
                    this.showVerifyButton = true;
                }
                this.updateRiderAndAddLog(result);
            },
                error => {
                    this.showVerifyButton = true;
                    this.spinnerService.hide();
                    this.handleAadhaarApiError(error, error && error.message || 'Faced problem in verification of docs');
                });
    }

    private updateRiderAndAddLog(result: any) {

        this.aadharVerifyStatus = result.data.verificationStatus;
        this.aadharVerifyMessage = result.data.message;
        this.verificationPlatform = 'IN-D';
        this.verifiedOn = result.data.updatedAt;
        this.thirdPartyStatus = this.aadharData.status;
        this.thirdPartyMessage = result.data.message;
    }

    private updateRider(condition) {
        this._aadharService.updateRider(this.riderId, condition)
            .subscribe((result: any) => {
                console.log('Updated rider aadhar status.');
            }, error => {
                console.log('Error - Updated rider aadhar status.', error);
            });
    }


    private updateAadharVerifiedAndRemarks() {
        return new Promise(() => {
            const remarks = this.remarks ? this.remarks : null;
            this.updateAadharVerified();
            if (remarks) {
                this._aadharService.updateRemarks(this.data._id, remarks).subscribe(res => {

                    this.spinnerService.hide();
                    this._toastMessage.openSnackBarSuccess('Remarks is updated!');
                },
                    error => {
                        this.spinnerService.hide();
                        const errorMessage = error && error.error && error.error.message || 'Could not update remarks';
                        this._toastMessage.openSnackBarError(errorMessage);
                    });
            }
        });
    }

    private updateAadharInfoAndRemarksForApproval() {
        return new Promise(() => {
            const remarks = this.remarks ? this.remarks : null;
            this.approveAadharInfo();
            if (remarks) {
                this._aadharService.updateRemarks(this.data._id, remarks).subscribe(res => {

                    this.spinnerService.hide();
                    this._toastMessage.openSnackBarSuccess('Remarks is updated!');
                },
                    error => {
                        this.spinnerService.hide();
                        const errorMessage = error && error.error && error.error.message || 'Could not update remarks';
                        this._toastMessage.openSnackBarError(errorMessage);
                    });
            }
        });
    }

    private approveAadharInfo() {
        this._aadharService.approveAadhar(this.data._id, 'true', this.aadharName, this.aadharNumber, false, this.isAadharInKyc)
            .subscribe(res => {
                this.aadharStatus.emit(true);
                this.showApproveButton = false;
                this.updateImageEnabled = false;
                this.showVerifyButton = false;
                this.spinnerService.hide();
                const view = this.showFront ? 'front' : this.showBack ? 'back' : '';
                this.dismissDuplicateError();
                this.aadharData.status = this.verificationStatus.ACCEPTED;
                this._toastMessage.openSnackBarSuccess('Aadhar has been approved');
                this.formApprovalMessage();
            }, error => {
                this.showApproveButton = true;
                this.showVerifyButton = true;
                this.spinnerService.hide();
                this.handleAadhaarApiError(error, 'Could not approve Aadhar');
            });
    }

    private updateAadharVerified() {
        this._aadharService.updateVerified(this.data._id, 'true', false, this.isAadharInKyc)
            .subscribe(res => {
                this.aadharStatus.emit(true);
                this.showApproveButton = false;
                this.updateImageEnabled = false;
                this.showVerifyButton = false;
                this.spinnerService.hide();
                const view = this.showFront ? 'front' : this.showBack ? 'back' : '';
                this.dismissDuplicateError();
                this.aadharData.status = this.verificationStatus.ACCEPTED;
                this._toastMessage.openSnackBarSuccess('Aadhar has been approved');
                this.formApprovalMessage();
            }, error => {
                this.showApproveButton = true;
                this.showVerifyButton = true;
                this.spinnerService.hide();
                this.handleAadhaarApiError(error, 'Could not approve Aadhar');
            });
    }

    dismissDuplicateError() {
        this.duplicateErrorMessage = null;
        this.duplicateBannerDismissed = true;
        if (this.stickyDuplicateSnackRef) {
            this.stickyDuplicateSnackRef.dismiss();
            this.stickyDuplicateSnackRef = null;
        }
    }

    private showDuplicateError(message: string) {
        this.duplicateBannerDismissed = false;
        this.duplicateErrorMessage = message;
        // Never leave optimistic success UI when a duplicate is shown
        this.isAadharApproved = false;
        this.aadharApprovalMessage = null;
        this.isAadharVerified = false;
        this.thirdPartyStatus = null;
        this.thirdPartyMessage = null;
        this.verificationPlatform = null;
        this.verifiedOn = null;

        if (this.stickyDuplicateSnackRef) {
            this.stickyDuplicateSnackRef.dismiss();
        }
        // Same solid-red snackbar as "Aadhar number already exists." — dismiss only via ✕
        this.stickyDuplicateSnackRef = this._toastMessage.openSnackBarErrorSticky(message);
        this.stickyDuplicateSnackRef.onAction().subscribe(() => {
            this.dismissDuplicateError();
        });
    }

    private handleAadhaarApiError(error: any, fallbackMessage: string) {
        const errorBody = error && error.error;
        const message = (errorBody && errorBody.message)
            || (errorBody && errorBody.info && errorBody.info.message)
            || (error && error.message)
            || fallbackMessage;
        if (this.isAadhaarDuplicateError(errorBody, message)) {
            const mobile = (errorBody && errorBody.mobile)
                || (errorBody && errorBody.data && errorBody.data.mobile);
            const display = (mobile && message && String(message).indexOf(String(mobile)) === -1)
                ? `${String(message).replace(/\.$/, '')} (mobile: ${mobile})`
                : message;
            this.showDuplicateError(display);
            return;
        }
        this._toastMessage.openSnackBarError(message, this.constantService.errorToastDuration);
    }

    private isAadhaarDuplicateError(errorBody: any, message: string): boolean {
        if (errorBody && errorBody.isDuplicate) {
            return true;
        }
        // KYC DuplicateDocumentError codes for Aadhaar (2001–2004)
        const code = errorBody && errorBody.errorCode;
        if (code >= 2001 && code <= 2004) {
            return true;
        }
        // Do not treat bare `mobile` alone as duplicate — rely on codes/flags/keywords.
        const msg = (message || '').toLowerCase();
        return msg.indexOf('exists for other captain') !== -1
            || msg.indexOf('already exists') !== -1
            || msg.indexOf('duplicate') !== -1
            || msg.indexOf('linked with another') !== -1;
    }

    private maybeShowDuplicateFromDoc(aadharData: any) {
        if (this.duplicateBannerDismissed || this.duplicateErrorMessage || !aadharData) {
            return;
        }
        const aadhar = aadharData.aadhar || {};
        const remarks = (aadhar.remarks || aadhar.rejectRemarks || '').toString();
        const statusMessage = (aadharData.docVerificationStatus
            && aadharData.docVerificationStatus.aadhar
            && aadharData.docVerificationStatus.aadhar.message) || '';
        const combined = `${remarks} ${statusMessage}`.toLowerCase();
        if (combined.indexOf('already exists') !== -1
            || combined.indexOf('duplicate') !== -1
            || combined.indexOf('linked with another') !== -1
            || combined.indexOf('exists for other') !== -1) {
            this.duplicateErrorMessage = remarks || statusMessage;
        }
    }

    private isInvalid() {
        return (this.aadharNumberFormControl.errors && this.aadharNumberFormControl.errors.required) ||
            (this.aadharNumberFormControl.errors && this.aadharNumberFormControl.errors.pattern);
    }

    private isExisting() {
        return this.existingAadharNumber === this.aadharNumber;
    }

    private createAadharStatus(result) {
        const aadharStatus = this.aadharData.status ? this.aadharData.status : result.data.verificationStatus;
        const isAadharAccepted = this.aadharData.status === this.verificationStatus.ACCEPTED;
        const message = result.data.message || '';
        const aadharData = { name: result.data.requestName, image: result.data.requestImage } || {};
        const verifiedBy = result.data.type || '';
        const verifiedOn = result.data.updatedAt || '';

        return {
            'data': aadharData,
            'status': aadharStatus,
            message,
            isAadharAccepted,
            verifiedBy,
            verifiedOn
        };
    }
    updateVerificationCard(verificationStatus) {
        // Keep sticky duplicate error dominant over async verification refresh
        if (this.duplicateErrorMessage) {
            return;
        }
        this.thirdPartyStatus = verificationStatus.status;
        this.thirdPartyMessage = verificationStatus.message;
        this.verificationPlatform = verificationStatus.verifiedBy;
        this.verifiedOn = verificationStatus.verifiedOn;
        this.isAadharVerified = verificationStatus.status === this.verificationStatus.ACCEPTED
            || verificationStatus.status === this.verificationStatus.VERIFIED;
        this.showVerifyButton = !this.isAadharVerified;
        if (this.isAadharApproved) {
            this.showVerifyButton = false;
        }
    }

    ngOnDestroy() {
        if (this.stickyDuplicateSnackRef) {
            this.stickyDuplicateSnackRef.dismiss();
            this.stickyDuplicateSnackRef = null;
        }
        // Clean up zoom lens when component is destroyed
        this.imageZoomService.cleanup();
    }

}
